<template>
    <div class="optpl-filter-group" v-if="group.type !== 'source'">
        <h3>
            <a href="#" @click.prevent="toggleFilters">
                <span>{{ group.title_singular }}</span>
                <i class="opui-fa opui-fa-sort-asc" v-if="! open" style="top: 2px;"></i>
                <i class="opui-fa opui-fa-sort-desc" v-else       style="top: -4px;"></i>
            </a>
        </h3>

        <div class="optpl-filter-group__filters" v-if="open">
            <ul>
                <li v-for="(filter, index) in alwaysShownFilters" :key="filter.slug">
                    <input type="checkbox" v-model="filter.checked" :id="'optpl-filter-group__filters__' + filter.id" @change="filterTemplates(filter.id)" :value="filter.id">
                    <label :for="'optpl-filter-group__filters__' + filter.id">
                        <span>{{ filter.title }}</span>
                        <!-- <i v-if="filter.templates_count">{{ filter.templates_count }}</i> -->
                    </label>
                </li>

                <li v-for="(filter, index) in hiddenFilters" :key="filter.slug" v-if="more">
                    <input type="checkbox" v-model="filter.checked" :id="'optpl-filter-group__filters__' + filter.id" @change="filterTemplates(filter.id)" :value="filter.id">
                    <label :for="'optpl-filter-group__filters__' + filter.id">
                        <span>{{ filter.title }}</span>
                        <!-- <i v-if="filter.templates_count">{{ filter.templates_count }}</i> -->
                    </label>
                </li>
            </ul>
        </div>

        <a href="#" v-if="! more && open && hiddenFilters.length" @click.prevent="toggleMore" class="optpl-filter-group__more">Show {{ hiddenFilters.length }} more</a>
    </div>
</template>

<script>
export default {
    data() {
        return {
            filters:         [],
            open:            true,
            more:            false,
            moreLimit:       5,
        }
    },
    props: {
        group: { type: Object, required: true }
    },
    computed: {
        alwaysShownFilters() {
            return this.group.filters.filter((filter, index) => {
                return index < this.moreLimit
            })
        },

        hiddenFilters() {
            return this.group.filters.filter((filter, index) => {
                return index >= this.moreLimit
            })
        }
    },
    methods: {
        filterTemplates(id) {
            // We also need to toggle other checkboxes, to behave more like radio buttons
            this.group.filters.forEach((filter) => {
                // If the filter is not the one that was clicked, uncheck it
                if (filter.id !== id) {
                    filter.checked = false;
                }
            });

            this.$emit('filter')
        },

        toggleFilters() {
            this.open = ! this.open
        },

        toggleMore() {
            this.more = ! this.more
        },

        beforeEnter: function(el) {
            el.style.height = '0';
        },
        enter: function(el) {
            el.style.height = el.scrollHeight + 'px';
        },
        beforeLeave: function(el) {
            el.style.height = el.scrollHeight + 'px';
        },
        leave: function(el) {
            el.style.height = '0';
        }
    }
}
</script>

<style scoped>
.opui-filter-group__filters {
    transition: 150ms ease-out;
    overflow-y: hidden;
}
</style>
